// reducers/rootReducers.js
import { combineReducers } from 'redux';
// import user from '../pages/user/UserReducers'
import examReducers from '../pages/exam/examReducer'

const RootReducer = combineReducers({
    // user
    examReducers
});

export default RootReducer;
